import React, { useState, useEffect } from "react";
import { t } from "../../../utils/i18n";
import "./index.css";
import { calculateUsdAmount, generatePaymentUrl } from "./Helper";

import StoreInfo from "./components/StoreInfo";
import LinkForm from "./components/LinkForm";
import WidgetFooter from "./components/WidgetFooter";

const WidgetDoc = ({
  store_id,
  wallet_address,
  integration,
  showSuccessModal,
}) => {
  const [exchangeRates, setExchangeRates] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchExchangeRates();
  }, []);

  // Fetch exchange rates logic (remains in parent)
  const fetchExchangeRates = async () => {
    setIsLoading(true);
    try {
      const response = await fetch("https://open.er-api.com/v6/latest/USD");
      const data = await response.json();
      if (data && data.rates) {
        setExchangeRates(data.rates);
      } else {
        throw new Error("Invalid rates data structure");
      }
    } catch (error) {
      console.error("Error fetching exchange rates:", error);

      setExchangeRates({
        USD: 1,
        EUR: 0.93,
        GBP: 0.79,
        ZAR: 18.14,
        NGN: 1330.35,
        KES: 130.5,
        GHS: 13.8,
        AUD: 1.5,
        CAD: 1.35,
        JPY: 150.2,
      });
    } finally {
      setIsLoading(false);
    }
  };

  // Function to generate the actual payment link URL and shorten it
  const handleGenerateLink = async (formData) => {
    // Calculate USD amount
    let usdAmount = formData.amount; // Default if currency is USD
    if (
      formData.currency !== "USD" &&
      formData.amount &&
      exchangeRates &&
      exchangeRates[formData.currency]
    ) {
      usdAmount = calculateUsdAmount(
        formData.amount,
        formData.currency,
        exchangeRates
      );
    } else if (!exchangeRates || !exchangeRates[formData.currency]) {
      console.warn(
        `Exchange rate for ${formData.currency} not available. Using original amount as fallback USD amount.`
      );
      usdAmount = parseFloat(formData.amount).toFixed(2);
    } else {
      usdAmount = parseFloat(formData.amount).toFixed(2);
    }

    // Prepare parameters for URL generation
    const urlParams = {
      store_id: store_id,
      amount: formData.amount,
      currency: formData.currency,
      description: formData.description,
      redirect_url: formData.redirect_url,
      usd_amount: usdAmount,
    };

    // Generate and shorten the payment URL
    return await generatePaymentUrl(urlParams);
  };

  return (
    <div className="doc-container">
      <h1 className="doc-title">{t("store_integrations.widget.title")}</h1>

      <div className="doc-content">
        {/* Use the new components */}
        <StoreInfo storeId={store_id} walletAddress={wallet_address} />

        <LinkForm
          exchangeRates={exchangeRates}
          isLoadingRates={isLoading}
          onGenerateLink={handleGenerateLink}
          storeId={store_id}
          walletAddress={wallet_address}
          integration={integration}
          showSuccessModal={showSuccessModal}
        />
      </div>

      <WidgetFooter />
    </div>
  );
};

export default WidgetDoc;
